import { Outlet, NavLink } from "react-router-dom";

import { PencilIcon, EyeIcon, StarIcon, Squares2X2Icon } from '@heroicons/react/24/outline';
import SectionHeader from "../components/SectionHeader";

const StepIcon = ({ step }) => {
  switch (step) {
    case '/admin/design-and-engineering':
      return <PencilIcon className='h-5 w-5 text-ase-blue' />;
    case '/admin/design-and-engineering/overview':
      return <EyeIcon className='h-5 w-5 text-ase-blue' />;
    case '/admin/design-and-engineering/partners':
      return <StarIcon className='h-5 w-5 text-ase-blue' />;
    default:
      return <Squares2X2Icon className='h-5 w-5 text-ase-blue' />;
  }
}

const DesignAndEngineeringLayout = () => {
  const navItems = [
    {
      page: '/admin/design-and-engineering',
      label: 'Projects'
    },
    {
      page: '/admin/design-and-engineering/overview',
      label: 'Overview'
    },
    {
      page: '/admin/design-and-engineering/partners',
      label: 'Partners'
    }
  ];

  return (
    <div className='flex flex-col md:flex-row justify-between w-full gap-4 md:gap-8'>
      <div className='border-ase-blue border-x border-t rounded-lg h-fit md:w-[250px]'>
        <SectionHeader title='Design & Engineering' extraClasses="hidden md:flex" />

        <div className='flex gap-4 bg-ase-blue md:hidden overflow-scroll p-2 rounded-md'>
          {navItems.map(step => (
            <NavLink
              to={step.page}
              key={step.page}
              end
              className={({ isActive }) => `${isActive ? 'bg-white text-ase-blue' : 'bg-white text-black bg-opacity-65'} px-2 flex items-center gap-2 hover:text-ase-blue py-2 text-xs w-full rounded-md text-nowrap`}
            >
              <StepIcon step={step.page} />
              <span>{step.label}</span>
            </NavLink>
          ))}
        </div>

        <div className='hidden md:block bg-white p-2 border-b border-ase-blue rounded-b-lg'>
          {navItems.map(step => (
            <NavLink
              to={step.page}
              key={step.page}
              end
              className={({ isActive }) => `${isActive ? 'bg-ase-blue text-ase-blue bg-opacity-10' : 'text-black'} px-2 flex items-center gap-2 hover:text-ase-blue py-2 text-sm w-full rounded-md`}
            >
              <StepIcon step={step.page} />
              <span>{step.label}</span>
            </NavLink>
          ))}
        </div>
      </div>

      <div className="w-full overflow-hidden">
        <Outlet />
      </div>
    </div>
  )
}

export default DesignAndEngineeringLayout;
